const UploadFor = {
    newsletterArticleImage: 1,
};

export default UploadFor;
